import { GridOptions } from 'ag-grid-community';
import { CustomNoRowsOverlay } from './no-rows-overlay-renderer';
import { CustomLoadingCellRenderer } from './custom-loading-cell-renderer.js';

// If you change these, please ensure you update .scss files as needed.
export const CLASS_NAME = {
  MULTI_SELECT_HEADER_CHECKBOX: 'katal-header-checkbox',
  CONTROL_BAR_CONTAINER: 'top-bars-container',
  SELECTION_COLUMN_HEADER: 'selection-column-header',
  ACTION_BAR_CONTAINER: 'dg-select-action-bar',
};

// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const SIDE_BAR = {
  toolPanels: [
    {
      id: 'allFilter',
      labelDefault: 'Filters',
      labelKey: 'filters',
      toolPanel: 'agFiltersToolPanel',
    },
  ],
} as GridOptions['sideBar'];

// IMPORTANT: This object is referenced by our docsite in order to surface default grid config. If you move this import, ensure you update the data grid tutorial!
// NOTE: many of the grid options are calculated options. See `_gridOptions`
// from within `KatDataGrid`
export const DEFAULT_GRID_OPTIONS = {
  unSortIcon: true,
  stopEditingWhenCellsLoseFocus: false,
  suppressClickEdit: true,
  singleClickEdit: true,
  suppressRowDeselection: true,
  suppressRowClickSelection: true,
  suppressDragLeaveHidesColumns: true,
  showOpenedGroup: true,
  paginateChildRows: false,
  animateRows: true,
  detailRowAutoHeight: true,
  embedFullWidthRows: true, // to change sticky nature of detail grid
  sideBar: SIDE_BAR,
  suppressContextMenu: true,
  isExternalFilterPresent: () => false,
  noRowsOverlayComponent: CustomNoRowsOverlay,
  loadingCellRenderer: CustomLoadingCellRenderer,
};

// IMPORTANT: This object is referenced by our docsite in order to surface default grid config. If you move this import, ensure you update the data grid tutorial!
export const DEFAULT_COL_DEF = {
  flex: 1,
  resizable: true,
  filter: true,
  suppressMovable: true,
  icons: {
    sortAscending: '<kat-icon name="arrow-up" size="small"></kat-icon>',
    sortDescending: '<kat-icon name="arrow-down" size="small"></kat-icon>',
    sortUnSort: '<kat-icon name="unsorted" size="small"></kat-icon>',
  },
};

export const ACTION_COLUMN_ID = '_dg_action';
